<template>
  <div class="button-block" :style="containerStyles">
    <a 
      :href="content.url || '#'" 
      class="custom-button" 
      :style="buttonStyles"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ content.text || 'Botón' }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ButtonBlock',
  
  props: {
    content: {
      type: Object,
      default: () => ({
        text: 'Botón',
        url: '#',
        styles: {
          backgroundColor: '#007bff',
          color: '#FFFFFF',
          align: 'center'
        }
      })
    }
  },

  computed: {
    containerStyles() {
      return {
        textAlign: this.content.styles?.align || 'center',
        padding: '10px 0'
      }
    },

    buttonStyles() {
      return {
        backgroundColor: this.content.styles?.backgroundColor || '#007bff',
        color: this.content.styles?.color || '#FFFFFF',
        display: 'inline-block',
        padding: '8px 16px',
        borderRadius: '4px',
        textDecoration: 'none',
        fontWeight: '500',
        fontSize: '16px',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      }
    }
  }
}
</script>

<style scoped>
.button-block {
  margin: 10px 0;
}

.custom-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
</style> 